"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _PriceDisplay = _interopRequireDefault(require("../../common/pricing/PriceDisplay"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _colors = require("HubStyleTokens/colors");

var _CurrencySelectors = require("../../../selectors/CurrencySelectors");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-size: 16px;\n  line-height: 27px;\n  text-decoration: line-through;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-size: 20px;\n  font-weight: 600;\n  padding-right: 4px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-size: 20px;\n  font-weight: 600;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  text-align: center;\n  padding: 6px;\n  margin-bottom: 20px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var PricesContainer = _styledComponents.default.div.withConfig({
  displayName: "ShoppingCartPrices__PricesContainer",
  componentId: "sc-1bingjl-0"
})(_templateObject());

var StyledPriceDisplay = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "ShoppingCartPrices__StyledPriceDisplay",
  componentId: "sc-1bingjl-1"
})(_templateObject2());
var DiscountedPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "ShoppingCartPrices__DiscountedPrice",
  componentId: "sc-1bingjl-2"
})(_templateObject3(), _colors.OZ);
var CrossedOutPrice = (0, _styledComponents.default)(_PriceDisplay.default).withConfig({
  displayName: "ShoppingCartPrices__CrossedOutPrice",
  componentId: "sc-1bingjl-3"
})(_templateObject4(), _colors.PANTERA);

function ShoppingCartPrices(_ref) {
  var totalPrice = _ref.totalPrice;
  var currencyCode = (0, _reactRedux.useSelector)(_CurrencySelectors.activeCurrencySelector);
  var isDiscounted = totalPrice.monthly.calculatedPrice !== totalPrice.monthly.fullPrice;
  return _react.default.createElement(PricesContainer, {
    "data-selenium-id": "shopping-cart-prices-container",
    "data-discounted": isDiscounted
  }, _react.default.createElement(_H.default, {
    className: "m-bottom-2"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "bundles.shoppingCart.monthlyCost"
  })), isDiscounted ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(DiscountedPrice, {
    price: totalPrice.monthly.calculatedPrice,
    currencyCode: currencyCode
  }), _react.default.createElement(CrossedOutPrice, {
    price: totalPrice.monthly.fullPrice,
    currencyCode: currencyCode
  })) : _react.default.createElement(StyledPriceDisplay, {
    price: totalPrice.monthly.calculatedPrice,
    currencyCode: currencyCode
  }));
}

var _default = ShoppingCartPrices;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/shopping-cart/ShoppingCartPrices.js
// module id = 709
// module chunks = 5 6